import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { ITemplateVariables } from 'crono-fe-common/types/templateVariables';
import { useRoleCapabilities } from 'hooks/useRoleCapabilities';

export default function useGetTemplateVariables(
  //Resolves user-based snippets as this user instead of the caller. Manager only
  onBehalfUserId?: number,
) {
  const { isManager } = useRoleCapabilities();
  //The param is omitted rather than sent as the caller's own id: non-managers
  //asking for anybody else are rejected with 400
  const onBehalfOf = isManager ? onBehalfUserId : undefined;

  const request: Request = createGetTemplateVariablesRequest(onBehalfOf);

  const requestConfig = {
    //The response varies by user, so two callers asking differently cannot
    //read each other's cached answer
    queryKey: [ENDPOINTS.templateVariables.main, onBehalfOf],
    queryFn: () => client(request),
    staleTime: 10 * 60 * 1000,
  };

  const { data, ...rest } = useQuery<Response<ITemplateVariables>, CronoError>(
    requestConfig,
  );

  return { data, ...rest };
}

export const createGetTemplateVariablesRequest = (
  onBehalfUserId?: number,
): Request => {
  return {
    url:
      onBehalfUserId !== undefined
        ? `${ENDPOINTS.templateVariables.main}?onBehalfUserId=${onBehalfUserId}`
        : ENDPOINTS.templateVariables.main,
    config: {
      method: 'get',
    },
  };
};
